import { FC, useRef } from 'react';
import { GoalValue } from './WeeklyGoalWrapper';
import Eyes from './WeeklyIcons/Eyes';
import WeeklyGoalCorePanel from './WeeklyGoalCorePanel';
import { OverlayPanel } from 'primereact/overlaypanel';

interface Props {
  centerClasses: string;
  goalValues: GoalValue[] | null;
  openPanel?: boolean;
  triggerCenterRef: React.RefObject<HTMLButtonElement>;
}

const WeeklyGoalCore: FC<Props> = ({ centerClasses, goalValues, triggerCenterRef }) => {
  const op = useRef<OverlayPanel | null>(null);

  const goalCount = goalValues?.length ?? 0;
  const hasThreeOrMore = goalCount >= 3;

  const positionClasses = goalCount < 3 ? 'tw-left-[54px] tw-top-[12px]' : 'tw-left-[64px] tw-top-[12px]';
  const sizeClasses = 'tw-h-[29px] tw-w-[29px] tw-text-lg tw-cursor-pointer';
  const shadowStyle = hasThreeOrMore ? { boxShadow: '0 0 6px 3px rgba(255, 97, 97, 0.50)' } : undefined;
  const weeklyGoalButtonLabel =
    goalCount === 0
      ? 'weekly goal progress details: 0 skills completed'
      : `weekly goal: ${goalCount} skill${goalCount === 1 ? '' : 's'} completed`;

  return (
    <>
      <WeeklyGoalCorePanel goalValues={goalValues} refOp={op} triggerCenterRef={triggerCenterRef} />
      <button
        aria-label={weeklyGoalButtonLabel}
        className={`
          ${centerClasses}
          ${positionClasses}
          ${sizeClasses}
          tw-flex tw-items-center tw-justify-center
          tw-relative tw-border tw-border-solid
          tw-rounded-[1000px]
          tw-font-atkinson tw-font-bold
          tw-leading-none tw-text-stone-0
          tw-z-[5]
        `}
        style={shadowStyle}
        onClick={e => op.current?.toggle(e)}
        ref={triggerCenterRef}
      >
        {goalCount === 0 ? <Eyes /> : goalCount}
      </button>
    </>
  );
};

export default WeeklyGoalCore;
